import { render, staticRenderFns } from "./PageHeaderAdmin.vue?vue&type=template&id=318a02b0&scoped=true&"
import script from "./PageHeaderAdmin.vue?vue&type=script&lang=js&"
export * from "./PageHeaderAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318a02b0",
  null
  
)

export default component.exports